$(function() {

  /**
   * 規約のチェックボックスをオンにすると送信できるボタン。
   */
  var formAgreement = (function() {
    var $input = $('.form-Foot').find('input[type="checkbox"]');
    var $button = $('.form-Foot').find('button');
    if($button.length) {
      $button.prop('disabled', true);
      $input.on('change', function() {
        if ($(this).prop('checked') == false ) {
          $button.prop('disabled', true);
        } else {
          $button.prop('disabled', false);
        }
      })
    }
  })();

}());
